export const FIELD_ERROR_TYPE = 'field';
export const SCREENTABS_ERROR_TYPE = 'screenTabs';
